import { Container } from '@mui/material';
import { Section } from 'modules/common/components/Section';
import { Withdraw } from 'modules/withdrawal/components/Withdraw';

export function Withdrawal(): JSX.Element {
  return (
    <Section>
      <Container maxWidth="md">
        <Withdraw />
      </Container>
    </Section>
  );
}
